import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOnboardingStage } from "../../redux/attorneyDataSlice";
import { authenticatedFetch } from "../../network/api";
import Header from "../components/header";
import "./paymentSuccess.css";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((s) => s.attorneyData.attorneyData);

  useEffect(() => {
    const updateStageAndRefresh = async () => {
      if (!userData?.user_id) return;

      try {

        await authenticatedFetch("/api/attorney/webapp/updateOnboardingStage", {
          method: "POST",
          body: JSON.stringify({
            user_id: userData.user_id,
            onboarding_stage: 7,
          }),
        });

        // Refresh Redux with the latest onboarding_stage
        dispatch(fetchOnboardingStage(userData.user_id));
      } catch (e) {
        console.error("Failed to update onboarding stage on payment success:", e);
      }
    };

    updateStageAndRefresh();
  }, [dispatch, userData?.user_id]);

  return (
    <div className="payment-success-container">
      <Header />
      <div className="payment-success-content">
        <h1 className="payment-success-title">Payment Method Saved!</h1>
        <h2 className="payment-success-subtitle">You're all set up for billing</h2>
        <p className="payment-success-description">
          Your payment method has been successfully saved. You will be charged at the end of your billing periods based on the number of clients you have received from the platform.
        </p>
        <div className="payment-success-details">
          <div className="detail-item">
            <span className="detail-icon">💳</span>
            <span className="detail-text">Secure payment processing</span>
          </div>
          <div className="detail-item">
            <span className="detail-icon">📊</span>
            <span className="detail-text">Billing based on client count</span>
          </div>
          <div className="detail-item">
            <span className="detail-icon">🔄</span>
            <span className="detail-text">Automatic monthly billing</span>
          </div>
        </div>
        <button className="payment-success-button" onClick={() => navigate("/attorney/settings?tab=pricing")}>
          Return to Settings
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess; 